var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activation-info"},[_c('div',{staticClass:"activation-info__icon"},[_c('IconClock')],1),_c('div',{staticClass:"activation-info__text"},[(_vm.delay > 0)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getText())}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }